function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "list",
  fill: "#CBCBCB",
  d: "M3.313 16.4C2.587 16.4 2 16.981 2 17.7c0 .719.587 1.3 1.313 1.3.725 0 1.312-.581 1.312-1.3 0-.719-.587-1.3-1.313-1.3zm18.375-5.2H8.563c-.726 0-1.313.581-1.313 1.3 0 .719.587 1.3 1.313 1.3h13.124c.726 0 1.313-.581 1.313-1.3 0-.719-.587-1.3-1.313-1.3zm-18.375 0C2.587 11.2 2 11.781 2 12.5c0 .719.587 1.3 1.313 1.3.725 0 1.312-.581 1.312-1.3 0-.719-.587-1.3-1.313-1.3zm5.25-2.6h13.124C22.413 8.6 23 8.019 23 7.3c0-.719-.587-1.3-1.313-1.3H8.563c-.725 0-1.312.581-1.312 1.3 0 .719.587 1.3 1.313 1.3zm13.124 7.8H8.563c-.725 0-1.312.581-1.312 1.3 0 .719.587 1.3 1.313 1.3h13.124c.726 0 1.313-.581 1.313-1.3 0-.719-.587-1.3-1.313-1.3zM3.313 6C2.587 6 2 6.581 2 7.3c0 .719.587 1.3 1.313 1.3.725 0 1.312-.581 1.312-1.3 0-.719-.587-1.3-1.313-1.3z"
});

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.d595f8ec.svg";
export { ForwardRef as ReactComponent };